import React from "react";

const SlidersBackMobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="58.181"
      height="25"
      viewBox="0 0 58.181 25"
    >
      <g
        id="Raggruppa_1191"
        data-name="Raggruppa 1191"
        transform="translate(-35.379 -634)"
      >
        <g
          id="Raggruppa_931"
          data-name="Raggruppa 931"
          transform="translate(-2202.44 -8033)"
        >
          <g
            id="Tracciato_269"
            data-name="Tracciato 269"
            transform="translate(2270 8667)"
            fill="#303130"
          >
            <path
              d="M 14 10 L 2 10 C 1.448600053787231 10 1 9.551400184631348 1 9 L 1 2 C 1 1.448600053787231 1.448600053787231 1 2 1 L 14 1 C 14.55140018463135 1 15 1.448600053787231 15 2 L 15 9 C 15 9.551400184631348 14.55140018463135 10 14 10 Z"
              stroke="none"
            />
            <path
              d="M 2 2 L 2 9 L 14 9 L 14 2 L 2 2 M 2 0 L 14 0 C 15.10457038879395 0 16 0.8954296112060547 16 2 L 16 9 C 16 10.10457038879395 15.10457038879395 11 14 11 L 2 11 C 0.8954296112060547 11 0 10.10457038879395 0 9 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z"
              stroke="none"
              fill="#303130"
            />
          </g>
          <g
            id="Rettangolo_461"
            data-name="Rettangolo 461"
            transform="translate(2280 8681)"
            fill="#303130"
            stroke="#303130"
            stroke-width="2"
          >
            <rect width="16" height="11" rx="2" stroke="none" />
            <rect x="1" y="1" width="14" height="9" rx="1" fill="none" />
          </g>
          <g
            id="Rettangolo_462"
            data-name="Rettangolo 462"
            transform="translate(2288 8667)"
            fill="#303130"
            stroke="#303130"
            stroke-width="2"
          >
            <rect width="8" height="11" rx="2" stroke="none" />
            <rect x="1" y="1" width="6" height="9" rx="1" fill="none" />
          </g>
          <g
            id="Rettangolo_463"
            data-name="Rettangolo 463"
            transform="translate(2270 8681)"
            fill="#303130"
            stroke="#303130"
            stroke-width="2"
          >
            <rect width="8" height="11" rx="2" stroke="none" />
            <rect x="1" y="1" width="6" height="9" rx="1" fill="none" />
          </g>
        </g>
        <g
          id="Raggruppa_930"
          data-name="Raggruppa 930"
          transform="translate(106.94 1294) rotate(180)"
        >
          <path
            id="Tracciato_258"
            data-name="Tracciato 258"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(64.5 650.741) rotate(180)"
            fill="none"
            stroke="#303130"
            stroke-linecap="round"
            stroke-width="1.5"
          />
          <path
            id="Tracciato_259"
            data-name="Tracciato 259"
            d="M0,0,4.24,4.241,0,8.482"
            transform="translate(70.5 650.741) rotate(180)"
            fill="none"
            stroke="#303130"
            stroke-linecap="round"
            stroke-width="1.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default SlidersBackMobile;
